// MET-style base calorie burn rate per minute for each activity, calibrated
// for a 155 lb baseline person. Callers pass the user's actual weight so the
// function can scale the result.

export const calorieBurnRates = {
  'Aerobics': 6.5,
  'Arnold Shoulder Press': 6.0,
  'Balance Exercises': 2.5,
  'Barbell Rows': 5.5,
  'Barbell Shoulder Press': 6.0,
  'Bear Crawls': 6.0,
  'Bench Press': 5.0,
  'Bicep Curls': 4.0,
  'Boxing': 7.5,
  'Burpees': 8.0,
  'Calf Raises': 4.5,
  'Cat Cow Stretch': 2.0,
  'Childs Pose': 1.5,
  'Chin Ups': 7.5,
  'Cobra Pose': 2.0,
  'Cross Country Skiing': 8.0,
  'Crunches': 5.0,
  'Cycling': 6.0,
  'Dancing': 5.5,
  'Deadlifts': 6.0,
  'Decline Bench Press': 5.0,
  'Dips': 5.5,
  'Downward Dog': 2.5,
  'Dumbbell Flies': 4.5,
  'Dumbbell Rows': 5.0,
  'Dynamic Stretching': 3.0,
  'Elliptical': 6.5,
  'Foam Rolling': 2.0,
  'Front Delt Raise': 4.0,
  'Functional Movement Drills': 3.0,
  'Hammer Curls': 4.0,
  'Hamstring Stretch': 2.0,
  'High Knees': 7.0,
  'Hiking': 6.0,
  'Hip Openers': 2.5,
  'Incline Bench Press': 5.0,
  'Iso-Lateral High Row': 6.5,
  'Jogging': 7.0,
  'Jump Rope': 8.0,
  'Jumping Jacks': 6.0,
  'Kickboxing': 7.5,
  'Lat Pulldown': 5.5,
  'Lateral Delt Raise': 4.0,
  'Leg Curl': 4.0,
  'Leg Extension': 4.0,
  'Leg Press': 5.5,
  'Leg Raises': 4.5,
  'Lunges': 6.0,
  'Lunges Bodyweight': 5.5,
  'Mobility Drills': 3.0,
  'Mountain Climbers': 7.0,
  'Overhead Press': 5.5,
  'Pigeon Pose': 2.0,
  'Pilates': 3.5,
  'Plank': 3.0,
  'Pull Ups': 8.0,
  'Push Ups': 7.0,
  'Rear Delt Fly': 4.0,
  'Rowing': 7.0,
  'Running': 8.0,
  'Seated Cable Row': 6.0,
  'Seated Forward Bend': 2.0,
  'Shoulder Mobility': 2.5,
  'Side Plank': 3.5,
  'Sit Ups': 5.0,
  'Skating': 6.5,
  'Skull Crushers': 4.5,
  'Spinning': 7.0,
  'Sprinting': 9.0,
  'Squat Jumps': 7.5,
  'Squats': 6.0,
  'Stair Climbing': 7.0,
  'Step Ups': 6.0,
  'Stretching': 2.0,
  'Swimming': 6.0,
  'Tai Chi': 3.0,
  'Tricep Dips': 5.5,
  'Walking': 4.5,
  'Wall Sits': 4.0,
  'Yoga': 3.5,
  'Zottman Curls': 4.0,
  'Zumba': 6.5
};

const CALORIE_BASELINE_WEIGHT_LBS = 155;

/**
 * Calories burned for a single activity entry.
 *
 * @param {{activityType: string, time?: number, weightLifted?: number}} activity
 * @param {number|string} userWeightLbs - User body weight. Non-numeric or
 *   missing values fall back to the 155 lb baseline.
 * @returns {number} Integer calories.
 */
export function calculateCaloriesBurned(activity, userWeightLbs) {
  const normalizeKey = (str) => str.toLowerCase().replace(/[-\s]+/g, '_');
  const normalizedActivityType = normalizeKey(activity.activityType);
  const calorieBurnRatesKeys = Object.keys(calorieBurnRates).reduce((acc, key) => {
    acc[normalizeKey(key)] = calorieBurnRates[key];
    return acc;
  }, {});
  const baseRate = calorieBurnRatesKeys[normalizedActivityType] || 0;
  const time = activity.time || 0;
  const count = activity.count || 0;
  const weight = parseFloat(userWeightLbs) || CALORIE_BASELINE_WEIGHT_LBS;
  const weightFactor = weight / CALORIE_BASELINE_WEIGHT_LBS;
  const weightLiftedFactor = activity.weightLifted
    ? 1 + Math.floor(activity.weightLifted / 10) * 0.1
    : 1;
  // When time is 0 but reps were logged, estimate effective time from reps
  // (~3 seconds per rep = 0.05 minutes). This prevents reps-only activities
  // from showing 0 calories.
  const effectiveTime = time > 0 ? time : (count > 0 ? count * 0.05 : 0);
  return Math.round(baseRate * effectiveTime * weightFactor * weightLiftedFactor);
}
